import React from 'react';
import styled from 'styled-components';

interface IProps {
  metricLabel: string;
  metricUnits: string;
  testType: string;
  tags: string[];
  min: string;
  max: string;
  avg: string;
  style?: React.CSSProperties;
  timeframe: string;
}

const Container = styled.div`
  width: 100%;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const FlexRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;
const FlexItem = styled.div`
  flex: 1;
`;

const Stat = styled.span`
  text-align: right;
`;

const MetricHeader = (props: IProps): React.ReactElement => {
  return (
    <Container style={props.style}>
      <FlexRow>
        <FlexItem>
          <div>{props.testType}</div>
          <div>
            {props.tags.map(
              (t: string): React.ReactElement => (
                <span key={t}>{t}</span>
              )
            )}
          </div>
          <div>
            {props.metricLabel}
            {props.metricUnits !== ' ' ? `(${props.metricUnits})` : null}
          </div>
          <div>{props.timeframe}</div>
        </FlexItem>
        <FlexItem>
          <FlexRight>
            <Stat>Average: {props.avg}</Stat>
            <Stat>Max: {props.max}</Stat>
            <Stat>Min: {props.min}</Stat>
          </FlexRight>
        </FlexItem>
      </FlexRow>
    </Container>
  );
};

export { MetricHeader };
